<template>
  <transition name="fade">
    <div
      v-if="$store.state.screenHolder"
      class="screenholder">
      <component :is="$store.state.screenHolder" />
    </div>
  </transition>
</template>

<script>
import payment from './Holders/payment.vue';

export default {
  name: 'ScreenHolder',

  components: {
    payment,
  },
};
</script>

<style lang="scss">
  .screenholder {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    z-index: 1000;
  }

  .screenholder + .showcase {
    filter: blur(5px);
    overflow: hidden;
  }
</style>

<style scoped lang="scss">
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease-out;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>
